<template>
  <el-table
    :data="block.rows"
    size="small"
    max-height="280"
    class="table-block"
  >
    <el-table-column
      v-for="column in block.columns"
      :key="column.key"
      :label="column.label"
      :min-width="80"
    >
      <template #default="{ row }">
        <span data-testid="ai-chat-table-cell">{{
          display(row[column.key])
        }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { TableBlock } from '../../types'

/* the fallback for rows that no other block has a shape for */
defineProps<{
  block: TableBlock
}>()

const { t } = useI18n()

const display = (value: unknown): string => {
  if (value === null || value === undefined) return '–'
  if (typeof value === 'boolean') {
    return value
      ? t('aichat.main.blocks.table.yes')
      : t('aichat.main.blocks.table.no')
  }
  return String(value)
}
</script>

<style scoped>
.table-block {
  font-size: 0.75rem;
}
</style>
